module.exports = __webpack_public_path__ + "assets/img/weixin.fcd7aea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weixin.jpg
// module id = /bMT
// module chunks = 37 166